function session(state = {
    isPosting : false,
    fieldErrors : [],
    message : null
}, action) {
    switch(action.type) {
        case 'SESSION_USER_GET_START' :
            return state;
        case 'SESSION_USER_GET_SUCCESS' :
            sessionStorage.setItem('user', JSON.stringify(action.user));
            return {
                ...state,
                user : action.user,
                loggedAt : (new Date()).getTime()
            }
        case 'SESSION_USER_GET_FAILURE' :
            sessionStorage.removeItem('api_token');
            sessionStorage.removeItem('user');
            return {
                ...state,
                user : null,
                loggedAt : 0
            };
        case 'SESSION_POST_LOGIN_START' : 
            return {
                ...state,
                isPosting : true,
                fieldErrors : {},
            }
        case 'SESSION_POST_LOGIN_SUCCESS' :

            sessionStorage.setItem('api_token', action.user.api_token);
            sessionStorage.setItem('user', JSON.stringify(action.user));
            sessionStorage.removeItem('logged_at', (new Date()).getTime());
            return {
                ...state,
                isPosting : false,
                user : action.user,
                fieldErrors : {},
                loggedAt : (new Date()).getTime()
            }
        case 'SESSION_POST_LOGIN_FAILURE' :
            const { error } = action;
            if(error instanceof Error) {
                return {
                    ...state,
                    fieldErrors : {
                        email : [error.message]
                    },
                    isPosting : false
                }    
                
            }else {
                return {
                    ...state,
                    fieldErrors : error,
                    isPosting : false,
                }
            }

        case 'SESSION_LOGOUT' :
            sessionStorage.removeItem('api_token');
            sessionStorage.removeItem('user');
            return {
                ...state,
                user : null,
                loggedAt : 0
            }
        default :
            return state;
    }
}

export default session;


/** WEBPACK FOOTER **
 ** ./src/reducers/session.js
 **/